import React from 'react'

interface BoltProps {
  width?: number,
  height?: number
}

const Bolt = ({ height = 24, width = 24 }: BoltProps) => {
  return (
    <svg
      className="drift-default-icon drift-default-icon--bolt"
      width={width}
      height={height}
      viewBox="0 0 8 14"
    >
      <path
        fill="#FEF79E"
        fillRule="evenodd"
        stroke="#F5A623"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth=".938"
        d="M4.256 5.777h3.65L.716 15.935l2.721-7.927H.14l6.503-10.08-2.387 7.849z"
      />
    </svg>
  )
}

export default  Bolt
